import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Input, Button, Alert } from 'reactstrap'
import { addData } from '../../lib/progressCheck'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const AdminProgressCheckAdd = () => {
	const navigate = useNavigate()
	const { layout } = useParams()
	const role = useRoleBasedUrl()

	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [formData, setFormData] = useState({
		type: 'Awards',
		description: '',
		order: 0,
		score: 1
	})

	const handleInputChange = (e) => {
		const { name, value, type } = e.target
		setFormData((prev) => ({
			...prev,
			[name]: type === 'number' ? parseInt(value) || 0 : value
		}))
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)
		setError(null)

		try {
			await addData({
				type: formData.type,
				order: formData.order,
				description: formData.description,
				score: formData.score
			})

			navigate(`${process.env.PUBLIC_URL}/${role}/progress-check/${layout}`)
		} catch (err) {
			console.error('Error adding progress check:', err)
			setError('Failed to add progress check')
		} finally {
			setLoading(false)
		}
	}

	const handleCancel = () => {
		navigate(`${process.env.PUBLIC_URL}/${role}/progress-check/${layout}`)
	}

	return (
		<Container fluid>
			<Row>
				<Col sm="12">
					<Card>
						<CardBody>
							<div className="d-flex justify-content-between align-items-center mb-4">
								<h3>Add Progress Check</h3>
							</div>

							{error && (
								<Alert color="danger" className="mb-4">
									{error}
								</Alert>
							)}

							<form onSubmit={handleSubmit}>
								<Row>
									<Col md="6">
										<FormGroup>
											<Label className="form-control-label">Parameter</Label>
											<Input type="select" name="type" value={formData.type} onChange={handleInputChange} required disabled={loading}>
												<option value="Awards">Awards</option>
												<option value="Activities">Activities</option>
											</Input>
										</FormGroup>
									</Col>
									<Col md="6">
										<FormGroup>
											<Label className="form-control-label">Description</Label>
											<Input
												type="text"
												name="description"
												value={formData.description}
												onChange={handleInputChange}
												placeholder="Enter Description"
												required
												disabled={loading}
											/>
										</FormGroup>
									</Col>
									<Col md="6">
										<FormGroup>
											<Label className="form-control-label">Order</Label>
											<Input
												type="number"
												name="order"
												value={formData.order}
												onChange={handleInputChange}
												placeholder="Order"
												min="0"
												disabled={loading}
											/>
										</FormGroup>
									</Col>
									<Col md="6">
										<FormGroup>
											<Label className="form-control-label">Score</Label>
											<Input type="select" name="score" value={formData.score} onChange={handleInputChange} required disabled={loading}>
												<option value={1}>1</option>
												<option value={2}>2</option>
												<option value={3}>3</option>
												<option value={4}>4</option>
											</Input>
										</FormGroup>
									</Col>
								</Row>

								<div className="d-flex justify-content-between mt-4">
									<Button type="submit" color="primary" disabled={loading}>
										{loading ? 'Adding...' : 'Add Progress Check'}
									</Button>
									<Button type="button" color="secondary" onClick={handleCancel} disabled={loading}>
										Cancel
									</Button>
								</div>
							</form>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Container>
	)
}

export { AdminProgressCheckAdd }
